export default {
  path: 'check',
  name: '抽检',
  icon: 'RegularcustomersFilled2x',
  component: '@/pages/check/index',
  accessKey: '41',
};
